import { render, staticRenderFns } from "./course-report.vue?vue&type=template&id=230ae68c"
import script from "./course-report.vue?vue&type=script&lang=js"
export * from "./course-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports